export const STATUS_META = {
  received: { label: "Received", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  approved: { label: "Approved", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  scheduled: { label: "Scheduled", cls: "bg-violet-50 text-violet-800 border-violet-200" },
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  disputed: { label: "Disputed", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  void: { label: "Void", cls: "bg-stone-100 text-stone-500 border-stone-200" },
};

export const NEXT_STATUS = { received: "approved", approved: "scheduled", scheduled: "paid" };

export const AGING_LABEL = {
  current: "Current", "1_30": "1–30 days", "31_60": "31–60 days", "61_90": "61–90 days",
  "90_plus": "90+ days", no_due_date: "No due date",
};

export const fmtMoney = (v) => (v === null || v === undefined ? "—"
  : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(v));

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const inputCls = "w-full bg-brand-surface border border-brand-border rounded-md px-3 py-2 text-sm text-brand-ink focus:outline-none focus:border-brand-primary transition-colors duration-200";

export function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.received;
  return <span data-testid={testid} className={`inline-flex items-center text-[10px] uppercase tracking-[0.12em] px-2 py-1 rounded-full border ${m.cls}`}>{m.label}</span>;
}
